/** KAN-852: подпись "чей клиент" в приложении менеджера: ничей / ваш / у ФИО. */
import { cn } from '@/lib/utils';

const TONE: Record<string, string> = {
  ничей: 'bg-amber-50 text-amber-800',
  ваш: 'bg-blue-50 text-blue-800',
};

export function MobileOwnerBadge({ label, testId }: { label: string; testId?: string }): JSX.Element {
  return (
    <span
      className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium', TONE[label] ?? 'bg-gray-100 text-gray-700')}
      data-testid={testId}
    >
      {label}
    </span>
  );
}
